import arrayUtilities from "../../utilities/arrayUtilities"
export const NumberInputWithCategory = ({ options, inputValueAndCategory, onChange }) => {

    return (
        <div className="input-group dynamic-unit-duration-input">
            <input className="form-control" min={0} type="number" value={ String(inputValueAndCategory.value) } onChange={ e => onChange(inputValueAndCategory.key, e.target.value) } />
            <div className="input-group-append">
                <button className="btn dropdown-toggle btn-falcon-default m-0 py-0 border" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    { !arrayUtilities.isNullOrEmpty(options) && options.find(item => item.key === inputValueAndCategory.key).value }
                </button>
                <div className="dropdown-menu dropdown-menu-right">
                    {
                        !arrayUtilities.isNullOrEmpty(options) &&
                            options.map(item =>
                                <div key={ item.key }>
                                    <button onClick={ () => {
                                        onChange(item.key, inputValueAndCategory.value)
                                    } } className="dropdown-item"><span>{ item.value }</span></button>
                                </div>
                            )
                    }
                </div>
            </div>
        </div>
    )
}